export default __webpack_public_path__ + "static/media/michelle_williams.e0968644.png";